import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Observable } from 'rxjs';
import { DevExGalleryComponent } from '../../../devExtreme/src/devExGallery/devExGallery.component';
import { ComponentStyle } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import { GalleryModel, GalleryStyle, IGallery } from './abcGallery';

@Component({
    selector: 'abcGallery',
    template: '<ng-template #abcGallery></ng-template>',
    standalone: false
})
export class AbcGalleryComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('abcGallery', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  @Input('id') attrId: string;
  @Input('noDataText') noDataText: string;
  @Input('loadHtml') loadHtml: boolean;

  private _selectedIndex: number;
  private _slideshowDelay: number;
  private _width: string;
  private _height: string;
  private _visible: boolean;
  private _class: string;
  private _showIndicator: boolean;
  private _showNavButtons: boolean;
  private _rtlEnabled: boolean;
  private _loop: boolean;
  private _disabled: boolean;
  private _animationEnabled: boolean;
  private _animationDuration: number;
  private _swipeEnabled: boolean;
  private _focusStateEnabled: boolean;
  private _wrapAround: boolean;
  private _hoverStateEnabled: boolean;
  @Output() onItemClick = new EventEmitter();
  @Output() onItemContextMenu = new EventEmitter();
  @Output() onItemHold = new EventEmitter();
  @Output() onOptionChanged = new EventEmitter();
  @Output() onSelectionChanged = new EventEmitter();
  @Output() onContentReady = new EventEmitter();
  @Output() indexChanged = new EventEmitter();

  @Input()
  get selectedIndex() {
    return this._selectedIndex;
  }
  set selectedIndex(data) {
    if (this.componentRef) {
      this.componentRef.selectedIndex = data;
    }
    this._selectedIndex = data;
  }

  @Input()
  get width() {
    return this._width;
  }
  set width(data) {
    if (this.componentRef) {
      this.componentRef.width = data;
    }
    this._width = data;
  }

  @Input()
  get height() {
    return this._height;
  }
  set height(data) {
    if (this.componentRef) {
      this.componentRef.height = data;
    }
    this._height = data;
  }

  @Input()
  get visible() {
    return this._visible;
  }
  set visible(data) {
    if (this.componentRef) {
      this.componentRef.visible = data;
    }
    this._visible = data;
  }

  @Input()
  get animationDuration() {
    return this._animationDuration;
  }
  set animationDuration(data) {
    if (this.componentRef) {
      this.componentRef.animationDuration = data;
    }
    this._animationDuration = data;
  }

  @Input()
  get wrapAround() {
    return this._wrapAround;
  }
  set wrapAround(data) {
    if (this.componentRef) {
      this.componentRef.wrapAround = data;
    }
    this._wrapAround = data;
  }

  @Input()
  get class() {
    return this._class;
  }
  set class(data) {
    if (this.componentRef) {
      this.componentRef.class = data;
    }
    this._class = data;
  }

  @Input()
  get loop() {
    return this._loop;
  }
  set loop(data) {
    if (this.componentRef) {
      this.componentRef.loop = data;
    }
    this._loop = data;
  }

  @Input()
  get hoverStateEnabled() {
    return this._hoverStateEnabled;
  }
  set hoverStateEnabled(data) {
    if (this.componentRef) {
      this.componentRef.hoverStateEnabled = data;
    }
    this._hoverStateEnabled = data;
  }

  @Input()
  get slideshowDelay() {
    return this._slideshowDelay;
  }
  set slideshowDelay(data) {
    if (this.componentRef) {
      this.componentRef.slideshowDelay = data;
    }
    this._slideshowDelay = data;
  }

  @Input()
  get showIndicator() {
    return this._showIndicator;
  }
  set showIndicator(data) {
    if (this.componentRef) {
      this.componentRef.showIndicator = data;
    }
    this._showIndicator = data;
  }

  @Input()
  get showNavButtons() {
    return this._showNavButtons;
  }
  set showNavButtons(data) {
    if (this.componentRef) {
      this.componentRef.showNavButtons = data;
    }
    this._showNavButtons = data;
  }

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(data) {
    if (this.componentRef) {
      this.componentRef.disabled = data;
    }
    this._disabled = data;
  }

  @Input()
  get rtlEnabled() {
    return this._rtlEnabled;
  }
  set rtlEnabled(data) {
    if (this.componentRef) {
      this.componentRef.rtlEnabled = data;
    }
    this._rtlEnabled = data;
  }

  @Input()
  get animationEnabled() {
    return this._animationEnabled;
  }
  set animationEnabled(data) {
    if (this.componentRef) {
      this.componentRef.animationEnabled = data;
    }
    this._animationEnabled = data;
  }

  @Input()
  get focusStateEnabled() {
    return this._focusStateEnabled;
  }
  set focusStateEnabled(data) {
    if (this.componentRef) {
      this.componentRef.focusStateEnabled = data;
    }
    this._focusStateEnabled = data;
  }

  @Input()
  get swipeEnabled() {
    return this._swipeEnabled;
  }
  set swipeEnabled(data) {
    if (this.componentRef) {
      this.componentRef.swipeEnabled = data;
    }
    this._swipeEnabled = data;
  }

  private _dataSource: GalleryModel[];
  @Input()
  get dataSource() {
    return this._dataSource;
  }
  set dataSource(data) {
    if (this.componentRef) {
      this.componentRef.dataSource = data;
    }
    this._dataSource = data;
  }

  public htmlAttributes: IGallery;
  @Input() private style: ComponentStyle = ComponentStyle.DevExpress;
  private componentRef;
  eventListener = [];

  constructor(private abcComponentService: AbcComponentService) {
    this.style = ComponentStyle.DevExpress;
    this.rtlEnabled = this.abcComponentService.rtlEnabled;
  }

  ngOnInit() {
    this.setGalleryAttributesIfAvailable();
    this.createComponentInstance().subscribe((component) => {});
  }

  ngAfterViewInit() {}

  ngOnDestroy(): void {}

  createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      switch (this.style) {
        case ComponentStyle.Material: {
          break;
        }
        case ComponentStyle.DevExpress: {
          this.componentRef = this.abcComponentService.loadComponent(
            DevExGalleryComponent,
            this.viewContainerRef
          ).componentRef.instance;
          this.componentRef.selectedIndex = this.selectedIndex;
          this.componentRef.rtlEnabled = this.rtlEnabled ? this.rtlEnabled : false;
          if (this.htmlAttributes.dataSource) this.componentRef.dataSource = this.htmlAttributes.dataSource;
          this.componentRef.onItemClick.subscribe((event) => {
            this.itemClick(event);
          });
          this.componentRef.onItemContextMenu.subscribe((event) => {
            this.itemContextMenu(event);
          });
          this.componentRef.onItemHold.subscribe((event) => {
            this.itemHold(event);
          });
          this.componentRef.onSelectionChanged.subscribe((event) => {
            this.selectionChanged(event);
          });
          this.componentRef.onOptionChanged.subscribe((event) => {
            this.optionChnaged(event);
          });
          this.componentRef.onContentReady.subscribe((event) => {
            this.contentReady(event);
          });
          this.componentRef.indexChanged.subscribe((event) => {
            this.indexChanged.emit(event);
          });
          break;
        }
      }
      if (this.htmlAttributes.id) this.componentRef.attrId = this.htmlAttributes.id;
      this.componentRef.setGalleryStyle(this.htmlAttributes.setGalleryStyle());
      observer.next(this.componentRef);
    });
    return observable;
  }

  private setGalleryAttributesIfAvailable(): void {
    if (this.attrId) {
      const style: GalleryStyle = {
        height: this.height,
        width: this.width,
        visible: this.visible,
        disabled: this.disabled,
        class: this.class,
        loop: this.loop,
        focusStateEnabled: this.focusStateEnabled,
        noDataText: this.noDataText,
        swipeEnabled: this.swipeEnabled,
        selectedIndex: this.selectedIndex,
        animationEnabled: this.animationEnabled,
        animationDuration: this.animationDuration,
        showIndicator: this.showIndicator,
        showNavButtons: this.showNavButtons,
        loadHtml: this.loadHtml,
        hoverStateEnabled: this.hoverStateEnabled,
        wrapAround: this.wrapAround,
        slideshowDelay: this.slideshowDelay,
      };
      this.htmlAttributes = {
        id: this.attrId,
        dataSource: this.dataSource,
        setGalleryStyle: (galleryStyle) => (galleryStyle = style),
      };
    }
  }

  public contentReady(event) {
    this.onContentReady.emit(event);
  }

  public itemClick(event) {
    this.onItemClick.emit(event);
  }

  public itemContextMenu(event) {
    this.onItemContextMenu.emit(event);
  }

  public itemHold(event) {
    this.onItemHold.emit(event);
  }

  public optionChnaged(event) {
    this.onOptionChanged.emit(event);
  }

  public selectionChanged(event) {
    this.onSelectionChanged.emit(event);
  }

  public goToItem(index: number, animation: boolean) {
    return this.componentRef.goToItem(index, animation);
  }

  public repaint() {
    return this.componentRef.itemRefresh();
  }

  public updateDataSource(dataSource) {
    return this.componentRef.updateDataSource(dataSource);
  }

  public getSelectedIndex() {
    return this.componentRef.getSelectedIndex();
  }
}
